import { default as broker7MyLTdKQ9JMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue?macro=true";
import { default as doplnenie_45udajovuYmhefVrqQMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue?macro=true";
import { default as doplnenierIaOQ9NFspMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue?macro=true";
import { default as fotodokumentaciaSL8Z5o30aeMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue?macro=true";
import { default as kalkulacie1AouOeC3LkMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue?macro=true";
import { default as platbaMGBAfQu4NnMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue?macro=true";
import { default as ponukyVOhsMgKSZhMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue?macro=true";
import { default as rekapitulacia0nMf6bQwB5Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue?macro=true";
import { default as upsellnFoDFwkTJpMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue?macro=true";
import { default as vyrocieSdtIbSDZZzMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue?macro=true";
import { default as zavolajtemixqRMAzu4l8Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue?macro=true";
import { default as pageRm4wQDdx9AMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45test61aMIClZO9Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagex7krOP3ElqMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleb9zkQRlmI0Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsvrLIxm0qnrMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagO3W8sOu4NeMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorhNJwy4PrXoMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as category8jd8BaAd3hMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionMSkLq1HwHBMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesYGJDmZ69q6Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categorysY5Bsfe2DAMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleOXhD6B7d0aMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as section74PAWJciarMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as poistenie_45zivot_45uniqaXzZZyrZu12Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa?macro=true";
import { default as odhlasenie_45z_45mailinguVRwnRcWrGnMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu?macro=true";
import { default as complaintml2RSSIrUnMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint?macro=true";
import { default as contactJkhlbskJp1Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45termination7QWElw8aV7Meta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as zadosttoy43nCQEQMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thank8XXi9bWXDeMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniHq7yayNJ2hMeta } from "/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
export default [
  {
    name: "autopoistenie-broker",
    path: "/autopoistenie/broker",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/broker.vue")
  },
  {
    name: "autopoistenie-doplnenie-udajov",
    path: "/autopoistenie/doplnenie-udajov",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie-udajov.vue")
  },
  {
    name: "autopoistenie-doplnenie",
    path: "/autopoistenie/doplnenie",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/doplnenie.vue")
  },
  {
    name: "autopoistenie-fotodokumentacia",
    path: "/autopoistenie/fotodokumentacia",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/fotodokumentacia.vue")
  },
  {
    name: "autopoistenie-kalkulacie",
    path: "/autopoistenie/kalkulacie",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/kalkulacie.vue")
  },
  {
    name: "autopoistenie-platba",
    path: "/autopoistenie/platba",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/platba.vue")
  },
  {
    name: "autopoistenie-ponuky",
    path: "/autopoistenie/ponuky",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/ponuky.vue")
  },
  {
    name: "autopoistenie-rekapitulacia",
    path: "/autopoistenie/rekapitulacia",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/rekapitulacia.vue")
  },
  {
    name: "autopoistenie-upsell",
    path: "/autopoistenie/upsell",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/upsell.vue")
  },
  {
    name: "autopoistenie-vyrocie",
    path: "/autopoistenie/vyrocie",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/vyrocie.vue")
  },
  {
    name: "autopoistenie-zavolajtemi",
    path: "/autopoistenie/zavolajtemi",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/layers/carinsurancesk/pages/autopoistenie/zavolajtemi.vue")
  },
  {
    name: pageRm4wQDdx9AMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45test61aMIClZO9Meta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagex7krOP3ElqMeta?.name,
    path: "/magazin",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleb9zkQRlmI0Meta?.name,
    path: "/magazin/:article(.*)*",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsvrLIxm0qnrMeta?.name,
    path: "/magazin/vzory-dokumentov",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagO3W8sOu4NeMeta?.name,
    path: "/magazin/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorhNJwy4PrXoMeta?.name,
    path: "/magazin/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: category8jd8BaAd3hMeta?.name,
    path: "/magazin/:category(poistenie|financie)",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionMSkLq1HwHBMeta?.name,
    path: "/magazin/:category(poistenie|financie)/:section(cestovanie|zivot|dom-a-domacnost|auto|pozicky-a-uvery)",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesYGJDmZ69q6Meta?.name,
    path: "/magazin/all-articles",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageRm4wQDdx9AMeta?.name,
    path: "/slovnik-pojmov",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categorysY5Bsfe2DAMeta?.name,
    path: "/slovnik-pojmov/:category(poistenie)",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleOXhD6B7d0aMeta?.name,
    path: "/slovnik-pojmov/:category(poistenie)/:id(.*)*",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: section74PAWJciarMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: section74PAWJciarMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: poistenie_45zivot_45uniqaXzZZyrZu12Meta?.name,
    path: "/poistenie-zivot-uniqa",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/poistenie-zivot-uniqa")
  },
  {
    name: odhlasenie_45z_45mailinguVRwnRcWrGnMeta?.name,
    path: "/odhlasenie-z-mailingu",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/odhlasenie-z-mailingu")
  },
  {
    name: complaintml2RSSIrUnMeta?.name,
    path: "/reklamacie",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/complaint")
  },
  {
    name: contactJkhlbskJp1Meta?.name,
    path: "/kontakty",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45termination7QWElw8aV7Meta?.name,
    path: "/poistenie/zmena-poistovne-autopoistenie",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: zadosttoy43nCQEQMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/zadost",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thank8XXi9bWXDeMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniHq7yayNJ2hMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src2705657798/src/nuxt-porovnajto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  }
]